<template>
    <auth-card-template>
        <card-auth>
            <vue-recaptcha
                v-if="recaptchaKey"
                ref="recaptcha"
                size="invisible"
                :sitekey="recaptchaKey"
                :loadRecaptchaScript="true"
                @verify="$_recaptcha_onVerified"
                @expired="$_recaptcha_onExpired" />

            <div v-show="isLoadingResend">
                <h4 class="font-family-title font-weight-bold text-success text-center mb-6">Reenviar e-mail de verificação</h4>

                <div class="text-center text-lg mb-6">
                    <p>Por favor, aguarde um momento enquanto reenviamos o e-mail de verificação.</p>
                    <text-loading text="Processando" />
                </div>
            </div>

            <div v-if="isResendSuccess">
                <h4 class="font-family-title font-weight-bold text-success text-center mb-6">E-mail de verificação enviado!</h4>

                <p class="text-center text-lg mb-6">
                    Agora acesse sua caixa de entrada e clique no link de verificação enviado para confirmar seu e-mail.
                </p>

                <div class="text-center">
                    <router-link to="/auth/login" class="text-lg font-weight-semibold">Ir para o login</router-link>
                </div>
            </div>

            <div v-if="errorMessage">
                <h4 class="font-weight-bold text-danger text-center mb-6">Ocorreu um problema</h4>

                <div class="text-center text-lg mb-6">
                    {{ errorMessage }}
                </div>

                <div class="text-center">
                    <router-link to="/auth/login" class="text-lg font-weight-semibold">Voltar para o login</router-link>
                </div>
            </div>
        </card-auth>
    </auth-card-template>
</template>

<script>
    import VueRecaptcha     from 'vue-recaptcha'
    import recaptcha        from '@/mixins/recaptcha'
    import TextLoading      from '@/components/atoms/TextLoading'
    import CardAuth         from '@/components/organisms/CardAuth'
    import AuthCardTemplate from '@/components/templates/AuthCardTemplate'

    export default {
        mixins: [recaptcha],
        components: {
            VueRecaptcha,
            TextLoading,
            CardAuth,
            AuthCardTemplate
        },
        data() {
            return {
                recaptchaKey: '',
                userEmail: '',
                errorMessage: '',
                isLoadingResend: true,
                isResendSuccess: false,
            }
        },
        beforeRouteEnter(to, from, next)
        {
            if (to.query.email) {
                next(vm => { vm.userEmail = to.query.email; });
            }
            else {
                next('/auth/login');
            }
        },
        mounted()
        {
            this.recaptchaKey = process.env.VUE_APP_RECAPTCHA_SITE_KEY;

            this.$nextTick(() => {
                setTimeout(() => {
                    this.$_recaptcha_verify(this.resendEmail)
                }, 2000)
            });
        },
        methods: {
            /**
             * Reenviar e-mail de verificação.
             */
            resendEmail()
            {
                this.errorMessage = '';
                this.isLoadingResend = true;

                this.$api.post('/login/resend', { email: this.userEmail })
                    .then(response => {
                        this.isLoadingResend = false;
                        this.isResendSuccess = true;
                    })
                    .catch(error => {
                        let errorMessage = 'Desculpe, ocorreu um erro ao tentar processar a sua solicitação.';

                        if (typeof error.response.data.message !== 'undefined') {
                            errorMessage = error.response.data.message;
                        }

                        this.isLoadingResend = false;
                        this.errorMessage = errorMessage;
                        this.$refs.recaptcha.reset();
                    });
            }
        }
    }
</script>